
import React, { useState } from 'react';
import { FaUpload } from 'react-icons/fa'; 
import '../assets/styles/modal.css'; 

const UploadQRModal = ({ currentUserData, onClose, onSave, isLoading }) => {
  const [qrFile, setQrFile] = useState(null); 
  const [error, setError] = useState(null);

  const existingQrUrl = currentUserData.qrCodeUrl || null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setQrFile(file);
      setError(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    
    if (!qrFile && !existingQrUrl) {
        setError("Por favor, selecciona un archivo QR para continuar.");
        return;
    }
    
    // Llamamos a handleSaveProfile. Pasamos un objeto vacío para profileData
    // y el qrFile, ya que el ProfileView sabe cómo manejar ambos.
    onSave({}, qrFile);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 1100 }} onClick={onClose}>
      <div 
        className="modal-content" 
        style={{ maxWidth: '500px' }} 
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>&times;</button>
        
        <form onSubmit={handleSubmit}>
          <h2>Activar Servicio de Trading</h2>
          <p>
            Para activar tu Trading Automatizado, sube el Código QR de tu API Key de Binance.
          </p>

          {error && <div className="alert alert-danger">{error}</div>}

          <div className="input-group" style={{ textAlign: 'center' }}>
            <label>Código QR de Binance API</label>
            <p style={{ fontSize: '0.9em', color: '#666', marginTop: '5px' }}>
                {existingQrUrl 
                    ? "Ya existe un QR. Sube uno nuevo para reemplazarlo."
                    : "No tienes un código QR subido."
                }
            </p>
            
            <input 
              type="file" 
              onChange={handleFileChange}
              accept="image/png, image/jpeg"
              required={!existingQrUrl} 
              style={{ display: 'none' }}
              id="qr-upload-input"
            />
            
            <label htmlFor="qr-upload-input" className="btn btn-secondary" style={{ display: 'block', margin: '15px auto' }}>
                <FaUpload style={{ marginRight: '8px' }} /> 
                {qrFile ? `Archivo seleccionado: ${qrFile.name}` : 'Seleccionar Archivo'}
            </label>
            
            {qrFile && <p style={{ fontSize: '0.8em', color: 'green' }}>Listo para subir.</p>}

          </div>

          <div className="modal-actions" style={{ justifyContent: 'center' }}>
            <button 
              type="button"
              className="btn"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isLoading || (!qrFile && !existingQrUrl)}
            >
              {isLoading ? 'Subiendo...' : 'Subir y Activar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadQRModal;